import { useState } from "react";
import { toast } from "react-toastify";
import { EnvelopeIcon } from "@heroicons/react/24/outline";

import { Modal } from "../../../../../common/Atoms/Modal";
import { Button } from "../../../../../common/Atoms/Button";
import { InputTextAddon } from "../../../../../common/Atoms/InputTextAddon";
import { Paragraph } from "../../../../../common/Atoms/Typography/Paragraph";
import { useSendCustomDomainDnsMutation } from "../../../../services/api/customDomainApi/customDomain";

interface SendDnsModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  organisationId: string;
  domain: string;
}

export function SendDnsModal({ open, setOpen, organisationId, domain }: SendDnsModalProps) {
  const [sendDns, { isLoading }] = useSendCustomDomainDnsMutation();
  const [emails, setEmails] = useState(``);

  function handleClose() {
    setOpen(false);
    setEmails(``);
  }

  async function handleSend() {
    try {
      await sendDns({ organisationId, emails }).unwrap();
      toast.success(`DNS records sent`);
      handleClose();
    }
    catch (err) {
      toast.error(err?.data || `Could not send the DNS records. Please try again.`);
    }
  }

  return (
    <Modal
      open={ open }
      setOpen={ handleClose }
      title={ `Send DNS records` }
      icon={ <EnvelopeIcon className={ `text-paidniceGreen-500 h-5 w-5 mr-2` } /> }
    >
      <div className={ `space-y-4` }>
        <Paragraph>
          { `Email the DNS records for ${domain} to whoever manages your domain, e.g. your IT person or web developer. The email will say it was sent by you.` }
        </Paragraph>
        <InputTextAddon
          label={ `Send to` }
          value={ emails }
          name={ `emails` }
          onChange={ e => setEmails(String(e.value)) }
          onKeyDown={ e => e.key === `Enter` && !isLoading && emails.trim() && handleSend() }
          placeholder={ `it@example.com, dev@example.com` }
          subHeading={ `Separate multiple addresses with commas.` }
        />
        <div className={ `flex justify-end space-x-4 mt-4` }>
          <Button
            color={ `gray` }
            onClick={ handleClose }
            disabled={ isLoading }
          >
            { `Cancel` }
          </Button>
          <Button
            color={ `paidniceGreen` }
            onClick={ handleSend }
            loading={ isLoading }
            disabled={ isLoading || !emails.trim() }
          >
            { `Send` }
          </Button>
        </div>
      </div>
    </Modal>
  );
}
